import React, { createContext, useContext, useState, useEffect } from 'react';
import { tokens } from '../styles/tokens';

const lightColors = {
  bg: '#F5F5F5',
  bgCard: '#FFFFFF',
  bgCardHover: '#F0F0F0',
  bgChip: '#EBEBEB',
  bgChipActive: '#000000',
  text: '#1A1A1A',
  textSecondary: '#6B7280',
  textMuted: '#9CA3AF',
  accent: '#3081f6',
  accentHover: '#1a6de0',
  danger: '#E85D4A',
  dangerHover: '#D44A37',
  badge: '#3081f6',
  badgeBg: 'rgba(48,129,246,0.85)',
  cartBg: '#FF5722',
  cartBgActive: '#7A4F1E',
  border: '#E0E0E0',
  overlay: 'rgba(0,0,0,0.45)',
};

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    try {
      const saved = localStorage.getItem('menu_theme');
      return saved ? saved === 'dark' : true;
    } catch {
      return true;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('menu_theme', isDark ? 'dark' : 'light');
    } catch {}
  }, [isDark]);

  const value = {
    ...tokens,
    colors: isDark ? tokens.colors : lightColors,
    isDark,
    toggle: () => setIsDark((v) => !v),
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) return { ...tokens, isDark: true, toggle: () => {} };
  return ctx;
}
